export const userEngagement = (builder) => ({
    userEngagement: builder.mutation({
        query: ({ page, limit, fromDate, endDate, msisdn, status}) => {
            const token = JSON.parse(localStorage.getItem('TOKEN'))?.token || '';
            return {
                url: '/getusermanagementsummary',
                method: 'GET',
                params: { page, limit, fromDate, endDate, msisdn, status },
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                },
            };
        },
    }),
});